
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/job-seekers",
      function () {
        return require("private-next-pages/us/job-seekers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/job-seekers"])
      });
    }
  